import React from 'react';
import ReactDOM from 'react-dom/client';
import PaperHands from './PaperHands';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PaperHands />
  </React.StrictMode>
);
